import { all } from 'redux-saga/effects';

import authSaga from './auth/sagas';
import departmentsSaga from './departments/sagas';
import partDepartmentsSaga from './part-departments/sagas';
import newsSaga from './news/sagas';
// eslint-disable-next-line
export function* rootSaga() {
  yield all([authSaga(), departmentsSaga(), partDepartmentsSaga(), newsSaga()]);
}
